import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailCampaignManager } from "@/features/admin/components/email-campaign-manager";
import { PageContainer } from "@fleet/ui";

function AdminEmailCampaignsPage() {
  return (
    <PageContainer maxWidth="6xl">
      <EmailCampaignManager />
    </PageContainer>
  );
}

export interface AdminEmailCampaignsSearch {
  /** Deep-link: open the "new campaign" form. */
  new?: string;
}

export const adminEmailCampaignsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email/campaigns",
  validateSearch: (search: Record<string, unknown>): AdminEmailCampaignsSearch => ({
    new: search.new === "campaign" ? "campaign" : undefined,
  }),
  component: AdminEmailCampaignsPage,
});
